import axios from "../components/shared/axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const addPromoCode = async (params) => {
    return await axios.post(`${baseURL}/promo`, params);
};

export const getPromoCodes = async (pageNo, pageSize, param) => {
    let params = {};
    if (param) params = { pageNo, pageSize, ...param };
    else params = { pageNo, pageSize };
    return await axios.get(`${baseURL}/promos`, { params });
};

export const getPromoCodeById = async (pageNo, pageSize, id) => {
    const params = { pageNo, pageSize };
    return await axios.get(`${baseURL}/promo/${id}`, { params });
};

export const updatePromoCode = async (params, id) => {
    return await axios.put(`${baseURL}/promo/${id}`, params);
};

export const getPromoTransactions = async (pageNo, pageSize, param) => {
    let params = {};
    if (param) params = { pageNo, pageSize, ...param };
    else params = { pageNo, pageSize };
    return await axios.get(`${baseURL}/promo-transactions`, { params });
};

export const getUSDValue = (value) => {
    let amount = JSON.stringify(value);
    if(amount.length > 2){
      let cents = amount.slice(amount.length - 2, amount.length);
      let dollars = amount.slice(0, amount.length - 2)
      amount = `${dollars}.${cents}`;
    }else if(amount.length > 1){
      amount = `0.${amount}`;
    }else{
      amount = `0.0${amount}`;
    }
    return amount;
  }